const attachment_utility = require('civicsUtils/attachment_utility');
define(function(require) {
	var IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/cdr/inspections/{0}',
		parse:function(response){
			var data = response.data ? response.data : response;
			// data.inspectionAttachments = attachmentConverter.convertAttachments(data.inspectionAttachments ? data.inspectionAttachments : data.attachments)
			data.inspectionAttachments = data.inspectionAttachments || data.attachments
			attachment_utility.parseVirusScanStatus(data.inspectionAttachments);
			return data;
		}
	});
});
